import React, { useState } from 'react';
import { 
  Droplets, 
  Activity, 
  Calendar, 
  Wrench, 
  Sparkles, 
  Clock, 
  ArrowRight, 
  Info,
  Scale
} from 'lucide-react';
import ReconstitutionCalculator from './ReconstitutionCalculator';

export default function ToolsHub({ 
  protocols = [], 
  onSaveToProtocol = null,
  onOpenAddModalWithData = null 
}) {
  const [activeTool, setActiveTool] = useState('reconstitution');

  return (
    <main className="max-w-7xl mx-auto px-4 lg:px-8 py-8 space-y-8">
      
      {/* Tools Hub Header */}
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 border-b border-slate-800/80 pb-6">
        <div>
          <div className="flex items-center space-x-2 text-xs font-semibold text-sky-400 uppercase tracking-widest mb-1.5">
            <Wrench className="w-4 h-4" />
            <span>Stack Utilities & Laboratory Tools</span>
          </div>
          <h1 className="text-2xl sm:text-3xl font-extrabold text-white tracking-tight">
            Protocol Engineering Tools
          </h1>
          <p className="text-sm text-slate-400 mt-1 max-w-2xl">
            Precision biohacking utilities for peptide reconstitution, dosage calibration, and stack administration.
          </p>
        </div>

        {/* Tool selector buttons */}
        <div className="flex items-center space-x-2 overflow-x-auto pb-1">
          <button
            type="button"
            onClick={() => setActiveTool('reconstitution')}
            className={`flex items-center space-x-2 px-4 py-2.5 rounded-xl font-medium text-xs transition whitespace-nowrap ${
              activeTool === 'reconstitution'
                ? 'bg-gradient-to-r from-sky-500 to-indigo-600 text-white shadow-lg shadow-sky-500/20 font-semibold'
                : 'bg-slate-900 hover:bg-slate-800 text-slate-300 border border-slate-800'
            }`}
          >
            <Droplets className="w-4 h-4 text-sky-300" />
            <span>Reconstitution Calculator</span>
            <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-white/20 text-white ml-1">
              Active
            </span>
          </button>
        </div>
      </div>

      {/* Active Tool View */}
      {activeTool === 'reconstitution' && (
        <ReconstitutionCalculator
          protocols={protocols}
          onSaveToProtocol={onSaveToProtocol}
          onOpenAddModalWithData={onOpenAddModalWithData}
        />
      )}

      {/* Upcoming Tools Roadmap Cards */}
      <div className="pt-6 border-t border-slate-800/80 space-y-4">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-sm font-bold text-slate-300 uppercase tracking-wider flex items-center space-x-2">
              <Sparkles className="w-4 h-4 text-indigo-400" />
              <span>Upcoming Protocol Utilities</span>
            </h3>
            <p className="text-xs text-slate-500 mt-0.5">
              Additional scientific tools currently in development for your stack.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-4 rounded-xl bg-slate-900/40 border border-slate-800/60 relative overflow-hidden group">
            <div className="flex items-start justify-between">
              <div className="flex items-center space-x-3">
                <span className="p-2.5 rounded-xl bg-slate-800/80 text-sky-400 border border-slate-700/50">
                  <Calendar className="w-5 h-5" />
                </span>
                <div>
                  <h4 className="text-sm font-bold text-slate-200">
                    Titration & Dose Escalation Planner
                  </h4>
                  <p className="text-xs text-slate-500 mt-0.5">
                    Map multi-week ramp-up schedules with automated calendar alerts and dosage adjustment logs.
                  </p>
                </div>
              </div>
              <span className="px-2 py-0.5 rounded text-[10px] font-semibold bg-slate-800 text-slate-400 border border-slate-700">
                In Roadmap
              </span>
            </div>
          </div>
        </div>
      </div>

    </main>
  );
}
